import { PALETTE } from '../../../constants';

export default {
  normal: {
    width: 6,
    height: 13,
    color: PALETTE.secondaryText,
    thickness: 2,
  },
  large: {
    width: 9,
    height: 16,
    color: PALETTE.primaryActive,
    thickness: 2,
  },
  thickness: {
    thin: 1,
    normal: 2,
    thick: 3,
  },
  color: {
    primary: PALETTE.primaryText,
    primaryDisabled: PALETTE.primaryTextDisabled,
    primaryActive: PALETTE.touchableOpacityEnable,
    secondary: PALETTE.secondaryText,
    secondaryDisabled: PALETTE.secondaryTextDisabled,
  },
};
